<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">ATNOFS Publication (A Traversal Network of Feminist Servers)</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Publication, editorial</p>
        <p>A Traversal Network of Feminist Servers (ATNOFS) is a collaborative project formed around intersectional feminist, ecological servers. Understanding servers as computers that host space and services for communities around them, this project exists inside, and in between, roaming servers and different networks. Our decentralized programme occured in 5 locations (The Netherlands, Belgium, Romania, Greece, Austria) with the collaboration of 6 partners (Varia, LURK, Constant, HYPHA, Feminist Hack Meetings, and ESC).</p>
        <p>Each session is documented in one chapter of this publication, alongside two inserts that traverse
the events. Everyone involved introduced their own focus, and raised questions regarding the different aspects of our infrastructures, spaces, practices and modes of working together from ecological, intersectional and feminist
perspectives</p>

        <p>The publication can be downloaded for print and digitally <a href="https://varia.zone/ATNOFS/">here</a>. The publication is hosted on a multi-headed webpage, asynchronously maintained by a network of networks that includes: Systerserver, Constant, hypha, Varia, ooooo, Marloes de Valk, LURK, Anarchaserver, Psaroskalazines, esc mkl and rosa.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/atnofs/intro.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/atnofs/varia.png"></b-img>


      </b-col>
      <b-col md="4">
        <b-img class="img-fluid" src="media/atnofs/colophon.png"></b-img>
        <p></p>


      </b-col>

    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ATNOFSPub',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
